<h4 *ngIf="insumo.id">Movimentações do Insumo <b>{{insumo.nome}}</b></h4>
<h4 *ngIf="produto.id">Movimentações do Produto <b>{{produto.nome}}</b></h4>

<kendo-grid
  class="historico-movimentacoes-grid"
  [loading]="carregando"
  [data]="gridData"
  [pageSize]="paginacao.size"
  [skip]="paginacao.skip"
  [pageable]="true"
  [resizable]="true"
  (pageChange)="mudouPaginacao($event)">
  <kendo-grid-messages
    pagerPage="Página"
    pagerOf="de"
    pagerItems="itens"
    noRecords="Nenhuma movimentação registrada"
    loading="Carregando"
    pagerItemsPerPage="itens por página">
  </kendo-grid-messages>

  <ng-template kendoGridToolbarTemplate>
    <div class="historico-filtros">
      <div class="historico-filtro-campo">
        <label>De</label>
        <kendo-datepicker
          [(ngModel)]="filtro.inicio"
          [format]="'dd/MM/yyyy'"
          class="form-control">
        </kendo-datepicker>
      </div>

      <div class="historico-filtro-campo">
        <label>Até</label>
        <kendo-datepicker
          [(ngModel)]="filtro.fim"
          [format]="'dd/MM/yyyy'"
          class="form-control">
        </kendo-datepicker>
      </div>

      <button type="button" class="btn btn-blue" (click)="apliqueFiltro()">
        Aplicar período
      </button>
    </div>
  </ng-template>

  <kendo-grid-column title="Movimentação" [width]="150">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <div class="movimentacao-identificador">#{{movimentacao.id}}</div>
      <div class="movimentacao-etiquetas">
        <span class="badge"
              [ngClass]="{'badge-danger': movimentacao.quantidade < 0,
                          'badge-success': movimentacao.quantidade > 0,
                          'badge-secondary': movimentacao.quantidade === 0}">
          {{movimentacao.tipo}}
        </span>
        <span class="badge"
              [ngClass]="{'badge-warning': movimentacao.reservada,
                          'badge-success': movimentacao.confirmada,
                          'badge-danger': movimentacao.cancelada}">
          {{movimentacao.status}}
        </span>
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Insumo" [width]="230" *ngIf="exibirInsumo">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <small class="d-block text-muted" *ngIf="movimentacao.insumo?.codigo">
        Código {{movimentacao.insumo.codigo}}
      </small>
      <strong class="insumo-nome">
        {{movimentacao.insumo?.nome || '—'}}
      </strong>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Quantidade" [width]="135">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <strong class="quantidade-movimentada"
              [ngClass]="{'text-danger': movimentacao.quantidade < 0,
                          'text-success': movimentacao.quantidade > 0}">
        {{movimentacao.quantidade}} {{obtenhaDescricaoUnidade(movimentacao)}}
      </strong>
      <small class="d-block mt-1 text-muted">
        <i class="k-icon mr-1"
           [ngClass]="{'k-i-check-circle text-success': movimentacao.retornarEstoque,
                       'k-i-times-circle text-danger': !movimentacao.retornarEstoque}"></i>
        {{movimentacao.retornarEstoque ? 'Retornável' : 'Não retornável'}}
      </small>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Origem" [width]="185">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <ng-container *ngIf="movimentacao.pedido">
        <small class="d-block text-muted">Pedido</small>
        <a [routerLink]="'/admin/pedidos/detalhes/' + movimentacao.pedido.guid">
          <strong>{{movimentacao.pedido.codigo}}</strong>
        </a>
      </ng-container>

      <ng-container *ngIf="movimentacao.operador">
        <small class="d-block text-muted" [class.mt-2]="movimentacao.pedido">Operador</small>
        <strong>{{movimentacao.operador.nome}}</strong>
      </ng-container>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Datas" [width]="190">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <small class="d-block text-muted">Movimentação</small>
      <span class="data-movimentacao">
        {{movimentacao.horario | date: "dd/MM/yyyy HH:mm:ss"}}
      </span>

      <small class="d-block mt-2 text-muted">Processamento</small>
      <span class="data-movimentacao" *ngIf="possuiFotografiaFinanceira(movimentacao)">
        {{movimentacao.processadoEm | date: "dd/MM/yyyy HH:mm:ss"}}
      </span>
      <span class="text-warning" *ngIf="!possuiFotografiaFinanceira(movimentacao) && movimentacao.reservada">
        Aguardando confirmação
      </span>
      <span class="text-muted" *ngIf="!possuiFotografiaFinanceira(movimentacao) && movimentacao.cancelada">
        Sem processamento
      </span>
      <span *ngIf="!possuiFotografiaFinanceira(movimentacao) && !movimentacao.reservada && !movimentacao.cancelada">
        —
      </span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Financeiro" [width]="245" *ngIf="exibeDadosFinanceiros">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <ng-container *ngIf="possuiFotografiaFinanceira(movimentacao)">
        <div class="financeiro-valores">
          <div>
            <small class="d-block text-muted">Unitário</small>
            <strong>{{movimentacao.custoUnitario | currency:'BRL'}}</strong>
          </div>
          <div>
            <small class="d-block text-muted">Total</small>
            <strong>{{movimentacao.custoTotal | currency:'BRL'}}</strong>
          </div>
        </div>
        <small class="d-block mt-2 text-muted">
          Média: {{movimentacao.custoMedioAnterior == null ? '—' : (movimentacao.custoMedioAnterior | currency:'BRL')}}
          → {{movimentacao.custoMedioResultante | currency:'BRL'}}
        </small>
        <small class="d-block mt-1 text-muted">
          Saldo: {{movimentacao.saldoQuantidadeResultante}} {{obtenhaDescricaoUnidade(movimentacao)}}
          · {{movimentacao.valorResultante | currency:'BRL'}}
        </small>
      </ng-container>

      <span class="text-warning" *ngIf="!possuiFotografiaFinanceira(movimentacao) && movimentacao.reservada">
        Aguardando confirmação
      </span>
      <span class="text-muted" *ngIf="!possuiFotografiaFinanceira(movimentacao) && movimentacao.cancelada">
        Sem efeito financeiro
      </span>
      <span *ngIf="!possuiFotografiaFinanceira(movimentacao) && !movimentacao.reservada && !movimentacao.cancelada">
        —
      </span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Detalhes" [width]="280">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <ng-container *ngIf="movimentacao.motivoDaMovimentacao || movimentacao.observacao ||
                           movimentacao.justificativa || movimentacao.movimentacaoEstornada?.id; else semDetalhes">
        <strong class="d-block" *ngIf="movimentacao.motivoDaMovimentacao">
          {{movimentacao.motivoDaMovimentacao.descricao}}
        </strong>
        <span class="observacao-limitada text-muted"
              *ngIf="movimentacao.observacao"
              kendoTooltip
              [title]="movimentacao.observacao">
          {{movimentacao.observacao}}
        </span>
        <small class="d-block mt-1" *ngIf="movimentacao.justificativa">
          <b>Justificativa:</b> {{movimentacao.justificativa}}
        </small>
        <small class="d-block mt-1 text-muted" *ngIf="movimentacao.movimentacaoEstornada?.id">
          Estorno de #{{movimentacao.movimentacaoEstornada.id}}
        </small>
      </ng-container>
      <ng-template #semDetalhes>—</ng-template>
    </ng-template>
  </kendo-grid-column>
</kendo-grid>
